import { all, fork } from 'redux-saga/effects'
import { initialUserInfoFlow, loginOutFlow } from './login'
import changeLanguageFlow from './i18n'

export default function* rootSaga() {
  yield all([fork(initialUserInfoFlow), fork(loginOutFlow), fork(changeLanguageFlow)])
}
